<script>
export default {
    render: function (createElement) {
        return createElement('div', this.$slots.default)
    },
    mounted() {
        let container = document.body
        if(this.to){
            container = document.getElementById(this.to)
        }
        container.appendChild(this.$el);
    },
    props: {
        to: String
    }
}
</script>